import { RFINotifications } from '../../../cimsPage/instances/rfi'
import { Notifications } from '../../common'

const { View, Edit } = Notifications({
  edit: '682C6F06-5DB3-4207-A5F6-A986D82087F2',
  view: '3AFB5DE1-1797-4D49-9DD1-1CDF333222E4',
  page: RFINotifications,
})

export const ViewRFINotification = View
export const EditRFINotification = Edit

export type RFINotificationPermission =
  | typeof ViewRFINotification
  | typeof EditRFINotification
